// extracted by mini-css-extract-plugin
export var borderRadius = "_e4-4";
export var large = "_e4-3";
export var logoContainer = "_e4-0";
export var nameLogo = "_e4-2";
export var small = "_e4-1";